// AJAX newsletter signup (footer + newsletter section) — no page reload
(function () {
  function msgEl(form) {
    var host = form.querySelector('[data-newsletter-msg]');
    if (!host) {
      host = document.createElement('p');
      host.setAttribute('data-newsletter-msg', '');
      host.className = form.classList.contains('footer-newsletter') ? 'footer-newsletter__msg' : 'newsletter__msg';
      form.appendChild(host);
    }
    return host;
  }

  function show(form, text, isError) {
    var el = msgEl(form);
    el.textContent = text;
    var base = form.classList.contains('footer-newsletter') ? 'footer-newsletter__msg' : 'newsletter__msg';
    el.className = base + (isError ? ' ' + base + '--error' : '');
    el.setAttribute('aria-live', 'polite');
    el.style.display = 'block';
  }

  function endpoint(form) {
    var action = form.getAttribute('action') || '/contact';
    return action.split('#')[0];
  }

  async function submit(form) {
    var btn = form.querySelector('[type="submit"]');
    var input = form.querySelector('input[type="email"]');
    var email = input ? (input.value || '').trim() : '';

    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      show(form, 'Please enter a valid email address.', true);
      if (input) input.focus();
      return;
    }

    if (btn) btn.disabled = true;
    show(form, 'Subscribing…', false);

    try {
      var fields = new URLSearchParams();
      fields.set('form_type', 'customer');
      fields.set('utf8', '✓');
      fields.set('contact[email]', email);
      fields.set('contact[tags]', 'newsletter');

      var res = await fetch(endpoint(form), {
        method: 'POST',
        body: fields.toString(),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'text/html',
        },
      });

      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var url = res.url || '';
      var posted = url.indexOf('customer_posted=true') !== -1;

      var errNode = doc.querySelector(
        '.footer-newsletter__msg--error, .newsletter__msg--error, .errors, .form__message--error, .form-status--error'
      );
      var errText = errNode ? errNode.textContent.replace(/\s+/g, ' ').trim() : '';
      var alreadyTaken = /already been taken|already subscribed/i.test(errText);

      if (posted || alreadyTaken || !errText) {
        show(form, alreadyTaken ? "You're already on the list — thank you!" : 'Thanks — welcome to the family.', false);
        if (input) input.value = '';
      } else {
        show(form, errText, true);
      }
    } catch (e) {
      show(form, 'Something went wrong. Please try again.', true);
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    submit(e.currentTarget);
    return false;
  }

  function bindForms(root) {
    var forms = root.querySelectorAll('form.footer-newsletter, form.newsletter__form');
    for (var i = 0; i < forms.length; i += 1) {
      if (forms[i].getAttribute('data-newsletter-ajax') === 'true') continue;
      forms[i].setAttribute('data-newsletter-ajax', 'true');
      forms[i].addEventListener('submit', handleSubmit, true);
    }
  }

  bindForms(document);
  document.addEventListener('DOMContentLoaded', function () { bindForms(document); });
  document.addEventListener('shopify:section:load', function (e) { bindForms(e.target); });
})();
